import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { token } from "./token.js";
function FilePlaceholder({
  children,
  ...props
}) {
  return /* @__PURE__ */ jsx(Placeholder, {
    ...props,
    children: /* @__PURE__ */ jsx(IconContainer, {
      children
    })
  });
}
const Placeholder = styled.div.withConfig({
  displayName: "Placeholder",
  componentId: "sc-1qwqjbg-0"
})(["display:grid;place-items:center;min-height:100px;"]);
const IconContainer = styled.div.withConfig({
  displayName: "IconContainer",
  componentId: "sc-1qwqjbg-1"
})(["display:grid;place-items:center;width:60px;height:70px;border-radius:", ";background:", ";color:", ";"], token.brandRadiusBase, token.gray10, token.gray600);
export {
  FilePlaceholder
};
//# sourceMappingURL=FilePlaceholder.js.map
